module.exports = __webpack_public_path__ + "assets/img/b4a511f3932f1c4bbc460f8402d4cd19.svg";